import { createRouter, createWebHashHistory } from 'vue-router'
import Beranda from '../views/BerandaView.vue'
import Artikel from '../views/ArtikelView.vue'
import Foto from '../views/FotoView.vue'
import Video from '../views/VideoView.vue'
import Profil from '../views/ProfilView.vue'
import Aturan from '../views/AturanView.vue'
import Faq from '../views/FaqView.vue'
import ArticleDetail from '../views/ArtikelDetail.vue'
import AturanDetail from '../views/AturanDetail.vue'

const routes = [
  {
    path: '/',
    name: 'beranda',
    component: Beranda
  },
  {
    path: '/oh4nvYyqLLXPHlteaBepbTEO8xTQ2tRCN0oc3ztR6R0=',
    name: 'artikel',
    component: Beranda
  },
  {
    path: '/eoJZ+vmZ2drETZbIHklwyBa7O/TY6RuVJqvkmwVP0ik=',
    name: 'foto',
    component: Beranda,
  },
  {
    path: '/QBUXVZtdDHnBbwibb4V3aHGjudScUMWXc/aBCur+aYM=',
    name: 'video',
    component: Beranda
  },
  {
    path: '/_art',
    name: 'art',
    component: Artikel
  },
  {
    path: '/_fot',
    name: 'fot',
    component: Foto
  },
  {
    path: '/_vid',
    name: 'vid',
    component: Video
  },
  {
    path: '/f3vCjFysfaYgBxnsDcfOh+0/+Jgv9HhEdkVzwJHNrvo=',
    name: 'profil',
    component: Profil
  },
  {
    path: '/W0OOXGIVabMoAhH8rNdMqkq5FjcunPK+CaXrRUBBVZY=',
    name: 'aturan',
    component: Aturan
  },
  {
    path: '/detail_aturan/:id',
    name: 'detail_aturan',
    component: AturanDetail
  },
  {
    path: '/y9mpGq6gyPvCumKeuzsP5RJyplziJtQmRS5529r4ApY=',
    name: 'faq',
    component: Faq
  },
  { 
    path: '/detail_article/:id', 
    name: 'detail_article',
    component: ArticleDetail 
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  linkActiveClass: "active", // active class for non-exact links.
  linkExactActiveClass: "active" // active class for *exact* links.
})
router.replace({ path: '#', redirect: '/' })
export default router
